import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { deleteCloudStream, fetchCloudStreams } from "../api/cloudStreamsApi";

const QUERY_KEY = ["cloud-streams"];

export const useCloudStreamsQuery = () => {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: fetchCloudStreams,
  });
};

export const useDeleteCloudStream = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => deleteCloudStream(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY });
    },
  });
};
